import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Subject} from 'rxjs/Subject';
import {UtilConfig} from "../../../autenticacion/servicios/UtilConfig";

@Injectable()
export class LayoutService {
    private docker = new Subject<any>();
    private colorIcons = new Subject<string>();
    private colorTitle = new Subject<string>();
    private colorText = new Subject<string>();
    private usuarioSession = new Subject<any>();
    private activoNotificacionesEscritorio = new Subject<any>();
    private activoNotificacionesAudio = new Subject<any>();

    constructor(private util: UtilConfig) {
        this.docker.next(util.getDocker());
        this.colorIcons.next(util.getColorIcons());
        this.colorTitle.next(util.getColorTitle());
        this.usuarioSession.next(this.util.getCurrentUser());
        this.activoNotificacionesEscritorio.next(this.util.getActivoNotEscritorio());
        this.activoNotificacionesAudio.next(this.util.getActivoNotAudio());
    }

    actualizarDock() {
        this.docker.next(this.util.getDocker());
    }

    actualizarSession() {
        this.usuarioSession.next(this.util.getCurrentUser());
    }

    clearDocker() {
        this.docker.next();
    }

    clearUsuarioSession() {
        this.usuarioSession.next();
    }

    getDocker(): Observable<any> {
        return this.docker.asObservable();
    }

    actualizarColorIcons() {
        this.colorIcons.next(this.util.getColorIcons());
    }

    getColorIcons(): Observable<string> {
        return this.colorIcons.asObservable();
    }

    actualizarColorTitle() {
        this.colorTitle.next(this.util.getColorTitle());
    }

    getColorTitle(): Observable<string> {
        return this.colorTitle.asObservable();
    }

    actualizarColorText() {
        this.colorText.next(this.util.getColorText());
    }


    getColorText(): Observable<string> {
        return this.colorText.asObservable();
    }

    getUsuarioSession(): Observable<any> {
        return this.usuarioSession.asObservable();
    }

    actualizarActivoNotAudio() {
        this.activoNotificacionesAudio.next(this.util.getActivoNotAudio());
    }

    getActivoNotAudio(): Observable<any> {
        return this.activoNotificacionesAudio.asObservable();
    }

    getActivoNotEscritorio(): Observable<any> {
        return this.activoNotificacionesEscritorio.asObservable();
    }

    actualizarActivoNotEscritorio() {
        this.activoNotificacionesEscritorio.next(this.util.getActivoNotEscritorio());
    }

}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/recursos/servicio/layout.service.ts